if (!customElements.get("bene-concept-popup")) {
  class BeneConceptPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;

      this.dialog = this.querySelector("dialog");
      if (!this.dialog) return;

      this.initialised = true;
      this.popupId = this.dataset.popupId;
      this.opener = null;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onDialogClick = this.onDialogClick.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);

      this.initTriggers();

      this.querySelectorAll("[data-popup-close]").forEach((button) => {
        button.addEventListener("click", this.close);
      });

      this.dialog.addEventListener("click", this.onDialogClick);
      this.dialog.addEventListener("close", this.onDialogClose);
    }

    // Bind every button that points at this popup
    initTriggers() {
      if (!this.popupId) return;

      document
        .querySelectorAll(`[data-popup-open="${this.popupId}"]`)
        .forEach((trigger) => trigger.addEventListener("click", this.open));
    }

    open(event) {
      this.opener = event && event.currentTarget ? event.currentTarget : null;

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }

      document.body.classList.add("overflow-hidden");
    }

    close() {
      if (typeof this.dialog.close === "function") {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute("open");
        this.onDialogClose();
      }
    }

    // Close when the backdrop next to the panel is clicked
    onDialogClick(event) {
      if (event.target === this.dialog) this.close();
    }

    onDialogClose() {
      document.body.classList.remove("overflow-hidden");

      if (this.opener && typeof this.opener.focus === "function") {
        this.opener.focus();
      }

      this.opener = null;
    }
  }

  customElements.define("bene-concept-popup", BeneConceptPopup);
}
